import React, { FC, useState } from 'react'

import { USAGE_METRIC, USAGE_METRIC_META } from 'constants/usageLimits'

import RequestSupervisionAccessModal from './RequestSupervisionAccessModal'
import * as S from './UsageMeter.style'

interface Props {
  botId: string | number
  canRequestIncrease?: boolean
}

const SupervisionGlyph: FC = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22 21v-2a4 4 0 0 0-3-3.87"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.13a4 4 0 0 1 0 7.75"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

/**
 * Shown in place of the Supervision card when the organisation's package does
 * not include Supervision: why the feature is absent and a way to request it.
 */
export const SupervisionUnavailableCard: FC<Props> = ({ botId, canRequestIncrease = true }) => {
  const [requestOpen, setRequestOpen] = useState(false)

  const label = USAGE_METRIC_META[USAGE_METRIC.SUPERVISION_SESSIONS]?.label || 'Supervision'

  return (
    <S.MeterCard>
      <S.MeterCardBody>
        <S.CardHead>
          <S.CardHeadLeft>
            <S.MeterIcon>
              <SupervisionGlyph />
            </S.MeterIcon>
            <S.MeterIdentity>
              <S.MeterLabel>{label}</S.MeterLabel>
            </S.MeterIdentity>
          </S.CardHeadLeft>
        </S.CardHead>

        <S.UnavailableText>
          Supervision isn&rsquo;t part of this organisation&rsquo;s current package.
          {canRequestIncrease && ' Request it and your admin will follow up to add it.'}
        </S.UnavailableText>
      </S.MeterCardBody>

      {canRequestIncrease && (
        <S.RequestButton onClick={() => setRequestOpen(true)}>Request supervision</S.RequestButton>
      )}

      {canRequestIncrease && requestOpen && (
        <RequestSupervisionAccessModal open={requestOpen} onClose={() => setRequestOpen(false)} botId={botId} />
      )}
    </S.MeterCard>
  )
}

export default SupervisionUnavailableCard
